import React from 'react';
import { Loader } from 'app/components/Loader';
import styles from '../SplitScrollTable.module.scss';

interface TableStatesProps {
  loading: boolean;
  initialLoad: boolean;
  error: string | null;
  hasData: boolean;
  children: React.ReactNode;
}

export const TableStates: React.FC<TableStatesProps> = ({
  loading,
  initialLoad,
  error,
  hasData,
  children
}) => {
  // Initial loading state - full screen overlay (like moments)
  if (loading && initialLoad) {
    return (
      <div
        className={styles.initialLoaderOverlay}
        data-testid="milestones-initial-loader"
      >
        <Loader />
      </div>
    );
  }

  // Subsequent loads - show data with refreshing indicator in header (handled by RoadmapHeader)
  // No need to block the UI here

  // Error state
  if (error) {
    return (
      <div className={styles.mainContainer}>
        <div className={styles.errorContainer}>
          Failed to load milestones data. Please try again.
        </div>
      </div>
    );
  }

  // No data state
  if (!hasData) {
    return (
      <div className={styles.mainContainer}>
        <div className={styles.noDataContainer}>No milestones available.</div>
      </div>
    );
  }

  // Render children when data is available
  return <>{children}</>;
};
